import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { IDealer, IDealersDataTableProps } from '../Dealers.types';

const DealersDataTable = (props: IDealersDataTableProps): JSX.Element => {
    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Dealer Id</th>
                    <th>Dealer Name</th>
                    <th>Locations</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.data && props.data.map((value: IDealer, index: number) => {
                    return (
                        <tr key={`row-${index}`}>
                            <td key={`dealer-id-${index}`}>{value.dealerId}</td>
                            <td key={`dealer-name-${index}`}>{value.dealerName}</td>
                            <td key={`dealer-locations-${index}`}>TODO</td>
                            <td key={`dealer-editCol-${index}`}>
                                <Button
                                    variant='secondary'
                                    onClick={_ => props.onEdit(value.id)}
                                    >
                                    Edit
                                </Button>
                            </td>
                            <td key={`dealer-deleteCol-${index}`}>
                                <Button
                                    variant='danger'
                                    onClick={_ => props.onDelete(value.id)}
                                    >
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default DealersDataTable;
